import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '@/components/Modal';
import { ComposeForm } from '@/pages/Mail/components/ComposeForm';
import { MailComposeMode, MailFolderType } from '@/types/components';
import type { MailMessage } from '@/types/mail';

interface Props {
  isOpen: boolean;
  mode: MailComposeMode;
  folderType: MailFolderType;
  sourceMail?: MailMessage | null;
  onClose: () => void;
  onSent: () => void;
}

export const ComposeModal: React.FC<Props> = ({
  isOpen,
  mode,
  folderType,
  sourceMail,
  onClose,
  onSent,
}) => {
  const { t } = useTranslation();
  const clickOutsideRef = useRef<(() => boolean) | null>(null);

  return (
    <Modal
      isOpen={isOpen}
      label={t('mail.composeModal.title')}
      className="md:h-[788px] md:max-h-[calc(100svh-80px)] md:w-[min(853px,calc(100vw-40px))]"
      onClickOutside={() => clickOutsideRef.current?.() ?? false}
      onClose={onClose}
    >
      <ComposeForm
        key={`${mode}-${sourceMail?.id ?? ''}`}
        mode={mode}
        folderType={folderType}
        sourceMail={sourceMail}
        clickOutsideRef={clickOutsideRef}
        onClose={onClose}
        onSent={onSent}
      />
    </Modal>
  );
};
